<div class="ft-form">
    <div class="content">
        <div class="ft-form-row col1-v100">
            <div class="ft-form-input">
                <label>{{ "lbl_given_name" | translate }}<span class="validation-message">*</span></label>
                <input type="text" [(ngModel)]="profile.firstName" (ngModelChange)="checkDirty()">
            </div>
        </div>
        <div class="ft-form-row col1-v100">
            <div class="ft-form-input">
                <label>{{ "lbl_middle_name" | translate }}</label>
                <input type="text" [(ngModel)]="profile.middleName" (ngModelChange)="checkDirty()">
            </div>
        </div>
        <div class="ft-form-row col1-v100">
            <div class="ft-form-input">
                <label>{{ "lbl_last_name" | translate }}<span class="validation-message">*</span></label>
                <input type="text" [(ngModel)]="profile.lastName" (ngModelChange)="checkDirty()">
            </div>
        </div>

        <div *ngIf="profileSaveSuccess" class="success-message">
            {{ "user_profile.lbl_profile_saved_success" | translate }}
        </div>
        <div *ngIf="unknownError" class="fail-message">
            {{ "user_profile.lbl_system_fail" | translate }}
        </div>

        <div class="ft-form-row save-btn-row">
            <button class="ft-btn" [ngClass]="isFormDirty ? 'ft-btn-active' : 'ft-btn-inactive'"
                [disabled]="!isFormDirty" (click)="saveUser()">
                {{ "lbl_save" | translate }}
            </button>
        </div>

        <hr>
        <div class="ft-form-row">
            <button class="ft-btn ft-btn-active" (click)="togglePassword()">
                {{ showPasswordForm ? ("user_profile.lbl_hide_password" | translate) :
                ("user_profile.lbl_change_password" | translate) }}
            </button>
        </div>

        <div *ngIf="showPasswordForm">
            <div class="ft-form-row col1-v100">
                <div class="ft-form-input password-wrapper">
                    <label>{{ "user_profile.lbl_current_password" | translate }}<span class="validation-message">*</span></label>
                    <input [type]="passwordFieldTypes.current" [(ngModel)]="password.current"
                        (ngModelChange)="validatePasswordMatchOldNew()" />
                    <img src="{{ passwordFieldTypes.current === 'password' ? '/assets/images/icons/close_eye.png' : '/assets/images/icons/open_eye.png' }}"
                        (click)="togglePasswordVisibility('current')" class="toggle-password" />
                </div>
            </div>

            <div class="ft-form-row col1-v100">
                <div class="ft-form-input password-wrapper">
                    <label>{{ "user_profile.lbl_new_password" | translate }}<span class="validation-message">*</span></label>
                    <input [type]="passwordFieldTypes.new" [(ngModel)]="password.new" (ngModelChange)="validatePassword()" />
                    <img src="{{ passwordFieldTypes.new === 'password' ? '/assets/images/icons/close_eye.png' : '/assets/images/icons/open_eye.png' }}"
                        (click)="togglePasswordVisibility('new')" class="toggle-password" />
                    <small class="text-danger" *ngIf="passwordErrorMessage">
                        {{ passwordErrorMessage }}
                    </small>
                </div>
            </div>

            <div class="ft-form-row col1-v100">
                <div class="ft-form-input password-wrapper">
                    <label>{{ "user_profile.lbl_confirm_password" | translate }}<span class="validation-message">*</span></label>
                    <input [type]="passwordFieldTypes.confirm" [(ngModel)]="password.confirm"
                        (ngModelChange)="validatePasswordMismatch()" />
                    <img src="{{ passwordFieldTypes.confirm === 'password' ? '/assets/images/icons/close_eye.png' : '/assets/images/icons/open_eye.png' }}"
                        (click)="togglePasswordVisibility('confirm')" class="toggle-password" />
                    <small class="text-danger" *ngIf="isPasswordMismatch">
                        {{ "user_profile.lbl_password_missmatch" | translate }}
                    </small>
                </div>
            </div>

            <div *ngIf="passwordSaveSuccess" class="success-message">
                {{ "user_profile.lbl_password_saved_success" | translate }}
            </div>

            <div *ngIf="incorrectPassword" class="fail-message">
                {{ "user_profile.lbl_password_incorrect" | translate }}
            </div>

            <div *ngIf="unknownError" class="fail-message">
                {{ "user_profile.lbl_system_fail" | translate }}
            </div>

            <div class="ft-form-row save-btn-row">
                <button class="ft-btn" [ngClass]="canSavePassword ? 'ft-btn-active' : 'ft-btn-inactive'"
                    [disabled]="!canSavePassword" (click)="changePassword()">
                    {{ "lbl_save" | translate }}
                </button>
            </div>
        </div>
        <hr>

         <div class="ft-form-row col1-v100">
            <div class="ft-form-input">
                <label>{{ "lbl_email" | translate }}</label>
                <input type="text" [value]="profile.email" disabled>
            </div>
        </div>
        
        <div class="ft-form-row col1-v100">
            <div class="ft-form-input">
                <label>{{ "user_profile.lbl_products" | translate }}</label>
                <textarea  class="products-textarea"  #productsTextarea [value]="productsText" disabled rows="1"></textarea>
            </div>
        </div>

    </div>

    <!-- Footer Cancel Button -->
    <div class="footer">
        <button class="ft-btn ft-btn-active-not-selected" (click)="cancel()">{{"lbl_cancel" | translate}}</button>
    </div>
</div>